import styles from './ServiceUser.module.css';
import '../../resources/css/admin_style.css';
import NavBar, { NavType } from "../NavBar/NavBar";
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../utils/loading/Loading";
import Header from "../Header/Header";
import { ModalContext } from "../../utils/modal/ModalProvider";
import { IAM_PATH, IAM_SERVER_SERVICE_USER, IAM_SERVER_SERVICE_GROUP } from "../../utils/Config";
import axios from "../../utils/api/axios";
import Datatable from "../../utils/datatable/Datatable";
import DetailModal from "../../utils/modal/DetailModal";
import { ServiceUserRegisterModal } from "./modal/ServiceUserRegisterModal";
import { ServiceUserDetailModal } from "./modal/ServiceUserDetailModal";
import 'react-datepicker/dist/react-datepicker.css';
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import ServiceUserTable from './ServiceUserTable';


export const ADMINROLE = {
    SYS_ADMIN: 'SYS_ADMIN',
    ADMIN_USER: 'ADMIN_USER'
}

/**
 * 서비스 사용자 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function ServiceUser({ isMobile, setMovePage }) {
    const [loading, setLoading] = useState(false);

    const { openModal } = useContext(ModalContext);
    const { closeModal } = useContext(ModalContext);

    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleRowClick = (userId) => {
        const modalContent = <ServiceUserDetailModal id={userId} update={fetchData} idToNameMap={idToNameMap} />
        const modalOption = { modalTitle: '유저 정보' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        fetchData();
    }, [page]);

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    const [serviceUsers, setServiceUsers] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    // 데이터 테이블 조회 API
    const fetchData = async (searchType = null, searchValue = null) => {
        setLoading(true);

        const conditions = []
        if (!(searchType == "" || searchValue == "")) {
            conditions.push(
                { "field": searchType, "operator": "like", "value": searchValue }
            );
        } else if (searchType == "status") {
            conditions.push(
                { "field": searchType, "operator": "equals", "value": searchValue == '활성화' ? true : false }
            );
        }

        const params = {
            startDate: 0,
            endDate: 0,
            page: page,
            size: listSize,
            sortField: ["id"],
            sortOrder: ["desc"],
            operator: "",
            conditions: conditions
        };

        try {
            const url = IAM_PATH + IAM_SERVER_SERVICE_USER + "/all";
            const res = await axios.post(url, params);

            const users = res.data.data.data;
            setTotalCount(res.data.data.totalCount);
            setServiceUsers(users.map(item => ({
                ...item,
                groupId: idToNameMap[item.groupId] || ''
            })));
        } catch (error) {
            console.error(error);
            showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
        } finally {
            setLoading(false);
        }
    }

    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (searchType, keyword) => {
        setPage(0);
        fetchData(searchType, keyword);
    };

    const [groups, setGroups] = useState([]);
    const [idToNameMap, setIdToNameMap] = useState({});

    const getGroups = async () => {
        const param = {
            startDate: 0,
            endDate: 0,
            page: 0,
            size: -1,
            sortField: [],
            sortOrder: [],
            operator: "",
            conditions: []
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_GROUP + "/all";
        const res = await axios.post(url, param);
        const { data } = res.data;

        const groupList = data.map(group => ({
            id: group.id,
            name: group.groupName
        }));

        const map = {};
        data.forEach(group => {
            map[group.id] = group.groupName;
        });

        setGroups(groupList);
        setIdToNameMap(map);
        return map; // ← map 반환
    };

    // // page 또는 정렬 조건이 바뀔 때마다 Reloading
    useEffect(() => {
        const fetchGroups = async () => {
            const map = await getGroups();  // map 반환 받기
            setIdToNameMap(map); // 비동기적으로 idToNameMap 설정
        };
        fetchGroups();
    }, []);

    useEffect(() => {
        // idToNameMap이 비어있지 않을 때만 fetchData 실행
        if (Object.keys(idToNameMap).length > 0) {
            fetchData();  // 인자 없이 idToNameMap 직접 참조
        }
    }, [idToNameMap]);


    const handleRegisterUser = () => {
        const modalContent = <ServiceUserRegisterModal update={fetchData} idToNameMap={idToNameMap} />
        const modalOption = { modalTitle: '사용자 등록' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    }

    // 그룹 유저 삭제
    const handleDeleteServiceUsers = (selectedIds) => {
        sessionStorage.getItem("id")
        setLoading(true)

        const url = IAM_PATH + IAM_SERVER_SERVICE_USER + "/delete";
        axios.post(url, { ids: selectedIds })
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                fetchData();
                setLoading(false)
            });
    };

    return (
        <div className={"adminWrap"}>
            <NavBar type={NavType.SERVICE_USER} />
            <section className={"rightCont"}>
                <Header />
                <div className={"rightCont__cont"}>
                    <h2 className={styles.sectionTitle}>· 관리자 관리</h2>
                    <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                        <div className={styles.permissionPanel}>
                            <ServiceUserTable
                                // groupId={selectedGroup != null ? selectedGroup.key : ""}
                                users={serviceUsers}
                                onAddUser={handleRegisterUser}
                                onDeleteUsers={handleDeleteServiceUsers}
                                detailUser={handleRowClick}
                                onPrevPage={handlePrevPage}
                                onNextPage={handleNextPage}
                                disablePrev={page === 0}
                                disableNext={(page + 1) * listSize >= totalCount}
                                pageNumber={page}
                                totalCount={totalCount}
                                listSize={listSize}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                onSearch={handleSearch}
                                isMobileWindow={isMobileWindow}
                            />
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default ServiceUser;